// frontend/src/hooks/useAuth.js

import { useAuthStore } from '../store/authStore'
import { authAPI } from '../services/api'
import toast from 'react-hot-toast'

export const useAuth = () => {
  const { token, refreshToken, user, setAuth, logout, setLoading, setError, clearError } =
    useAuthStore()

  // Локальная регистрация
  const register = async (email, password, username, firstName, lastName) => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.register({
        email,
        password,
        username,
        first_name: firstName,
        last_name: lastName,
      })

      const { access_token, refresh_token, user: userData } = response.data
      setAuth(access_token, refresh_token, userData)
      toast.success('Успешная регистрация!')
      return response.data
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Ошибка регистрации'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // Локальный вход
  const login = async (email, password) => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.login({
        email,
        password,
      })

      const { access_token, refresh_token, user: userData } = response.data
      setAuth(access_token, refresh_token, userData)
      toast.success('Успешный вход!')
      return response.data
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Ошибка входа'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // Получить текущего пользователя
  const getCurrentUser = async () => {
    try {
      const response = await authAPI.getCurrentUser()
      setAuth(token, refreshToken, response.data)
      return response.data
    } catch (error) {
      logout()
//      throw error
    }
  }

  // Выход
  const logoutUser = async () => {
    try {
      if (refreshToken) {
        await authAPI.logout(refreshToken)
      }
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      logout()
      toast.success('Вы вышли из системы')
    }
  }

  // OAuth Google - начало авторизации
  const startGoogleOAuth = async () => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.startGoogleOAuth()
      return response.data
    } catch (error) {
      const errorMsg = 'Ошибка при инициализации Google OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // OAuth Google - обработка callback
  const handleGoogleOAuthCallback = async (code, state) => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.googleOAuthCallback({
        code,
        state,
      })

      const { access_token, refresh_token, user: userData } = response.data
      setAuth(access_token, refresh_token, userData)
      toast.success('Успешная авторизация через Google!')
      return response.data
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Ошибка Google OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // OAuth GitHub - начало авторизации
  const startGitHubOAuth = async () => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.startGitHubOAuth()
      return response.data
    } catch (error) {
      const errorMsg = 'Ошибка при инициализации GitHub OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // OAuth GitHub - обработка callback
  const handleGitHubOAuthCallback = async (code, state) => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.gitHubOAuthCallback({
        code,
        state,
      })

      const { access_token, refresh_token, user: userData } = response.data
      setAuth(access_token, refresh_token, userData)
      toast.success('Успешная авторизация через GitHub!')
      return response.data
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Ошибка GitHub OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
//      throw error
    } finally {
      setLoading(false)
    }
  }

  // OAuth Yandex - начало авторизации
  const startYandexOAuth = async () => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.startYandexOAuth()
      return response.data
    } catch (error) {
      const errorMsg = 'Ошибка при инициализации Yandex OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  // OAuth Yandex - обработка callback
  const handleYandexOAuthCallback = async (code, state) => {
    setLoading(true)
    clearError()
    try {
      const response = await authAPI.yandexOAuthCallback({
        code,
        state,
      })

      const { access_token, refresh_token, user: userData } = response.data
      setAuth(access_token, refresh_token, userData)
      toast.success('Успешная авторизация через Яндекс!')
      return response.data
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Ошибка Yandex OAuth'
      setError(errorMsg)
      toast.error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  return {
    token,
    refreshToken,
    user,
    isAuthenticated: !!token,
    register,
    login,
    logout: logoutUser,
    getCurrentUser,
    startGoogleOAuth,
    handleGoogleOAuthCallback,
    startGitHubOAuth,
    handleGitHubOAuthCallback,
    startYandexOAuth,
    handleYandexOAuthCallback,
  }
}
